import { render } from "./fileMod.vue?vue&type=template&id=65d2f8a6&scoped=true"
import script from "./fileMod.vue?vue&type=script&lang=js"
export * from "./fileMod.vue?vue&type=script&lang=js"

import "./fileMod.vue?vue&type=style&index=0&id=65d2f8a6&scoped=true&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d2f8a6"]])

export default __exports__